<app-base-action-modal
  modalTitle="View Upcoming Payments"
  i18n-modalTitle
  primaryLabel="Close"
  i18n-primaryLabel
  [hideSecondary]="true"
  (closeClicked)="close()"
  (primaryClicked)="close()">
  <div class="d-flex flex-column gap-4">
    <div class="paragraph-md" i18n>Your next 5 payments, as of your current configuration, are outlined below.</div>
    <ul class="no-style-list payment-list">
      <li class="payment-row" *ngFor="let payment of displayedPayments">
        <div class="d-flex flex-column gap-1">
          <div class="payment-type">{{ payment.paymentType }}</div>
          <div class="payment-date">{{ payment.date | date : 'MMMM yyyy' }}</div>
        </div>
        <div class="payment-amount">{{ payment.amount | currency }}</div>
      </li>
    </ul>
  </div>
</app-base-action-modal>
